import { render, staticRenderFns } from "./CancelPrescription.vue?vue&type=template&id=b984b9c0&"
import script from "./CancelPrescription.vue?vue&type=script&lang=js&"
export * from "./CancelPrescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports